import validate from "/app/node_modules/.pnpm/nuxt@4.5.2_6210b4614a90d24ed7187407524aa20b/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.2_6210b4614a90d24ed7187407524aa20b/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-global-server": () => import("/app/app/middleware/redirect.global.server.ts"),
  "sanctum:auth": () => import("/app/node_modules/.pnpm/nuxt-auth-sanctum@3.1.1/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/app/node_modules/.pnpm/nuxt-auth-sanctum@3.1.1/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}